import { render, staticRenderFns } from "./payManageMechanism.vue?vue&type=template&id=1c0a411f&scoped=true"
import script from "./payManageMechanism.vue?vue&type=script&lang=js"
export * from "./payManageMechanism.vue?vue&type=script&lang=js"
import style0 from "./payManageMechanism.vue?vue&type=style&index=0&id=1c0a411f&prod&lang=less&scoped=true"
import style1 from "./payManageMechanism.vue?vue&type=style&index=1&id=1c0a411f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a411f",
  null
  
)

export default component.exports